module.exports = __webpack_public_path__ + "img/es-mb-banner.b5d664e5.png";